import { BindCustomDeckContextActions } from 'src/components/DNA';
import { CustomDeckORM, FolderItemORM } from 'src/types/types';
import { isCustomDeckORM } from 'src/types/typeguards';
import { AppDispatch } from 'src/state/redux';
import { DocumentVersionUpdateInfo } from 'src/state/redux/selector/folder';
import { folderActions } from 'src/state/redux/slice/folder';
import { customDeckActions } from 'src/state/redux/slice/customDeck';
import { upgradeFolderDocuments } from 'src/state/redux/saga';

export enum FolderItemStatus {
  AutoUpdated = 'AutoUpdated',
  Acknowledged = 'Acknowledged',
  Outdated = 'Outdated',
  Updated = 'Updated',
  Review = 'Review'
}

type DNAMyUpdatesButtonActionsType = {
  [key in keyof typeof FolderItemStatus]: {
    label: string,
    action?: (
      dispatch: AppDispatch,
      itemsInfo: DocumentVersionUpdateInfo[],
      customDeckEditorActions?: BindCustomDeckContextActions) => void,
  }
}

export const DNAMyUpdatesButtonActions: DNAMyUpdatesButtonActionsType = {
  AutoUpdated: {
    label: 'Acknowledge',
    action: (dispatch, itemsInfo) => {
      const folderItemORMs: FolderItemORM[] = []
      const customDeckORMs: CustomDeckORM[] = []
      itemsInfo.map(obj => {
        if (isCustomDeckORM(obj.folderItem.relations.itemORM)) {
          customDeckORMs.push(obj.folderItem.relations.itemORM)
        }
        else {
          folderItemORMs.push(obj.folderItem)
        }
      })
      dispatch(folderActions.acknowledgeAutoUpdate(folderItemORMs))
      dispatch(customDeckActions.acknowledgeAutoUpdate(customDeckORMs))

      // Update aux objects status
      // [TODO] - Don't mutate argument objects ...
      itemsInfo.forEach(item => {
        item.status = FolderItemStatus.Acknowledged
      })
    },
  },
  Acknowledged: { label: 'Acknowledged' },
  Outdated: {
    label: 'Update',
    action: (dispatch, itemsInfo) => {
      const folderItemIds: string[] = []
      const customDeckORMs: CustomDeckORM[] = []
      itemsInfo.map(obj => {
        if (isCustomDeckORM(obj.folderItem.relations.itemORM)) {
          customDeckORMs.push(obj.folderItem.relations.itemORM)
        }
        else {
          folderItemIds.push(obj.folderItem.model.id)
        }
      })

      upgradeFolderDocuments(
        dispatch,
        {
          folderItemId: folderItemIds,
          skipGracePeriod: true,
        },
      )
      dispatch(customDeckActions.upgradeCustomDecks({ customDeckORMs }))

      // Update aux objects status
      // [TODO] - Don't mutate argument objects ...
      itemsInfo.forEach(item => {
        item.status = FolderItemStatus.Updated
      })
    },
  },
  Updated: { label: 'Updated' },
  Review: {
    label: 'Review',
    action: (_, itemsInfo, customDeckEditorActions) => {
      const item = itemsInfo[0]
      if (isCustomDeckORM(item.folderItem.relations.itemORM)) {
        const customDeckORM = item.folderItem.relations.itemORM
        customDeckEditorActions?.edit(customDeckORM, item.folderItem, 'REVIEW')()
      }
    },
  },
}

export default DNAMyUpdatesButtonActions
